// Svelte 5 no longer needs svelte/store imports for basic reactivity

// Create reactive state for speakers
export const speakerState = $state([]);

export function clearSpeakerState(){
    speakerState.length = 0;
}

export function setSpeakerState(speakers) {
  // Clear existing event groups first
  clearSpeakerState();
  speakers.forEach(speaker =>{
    speakerState.push({
        ...speaker
    });
  })
}